import { render, staticRenderFns } from "./Space.vue?vue&type=template&id=942a2bf4&scoped=true&"
import script from "./Space.vue?vue&type=script&lang=ts&"
export * from "./Space.vue?vue&type=script&lang=ts&"
import style0 from "./Space.vue?vue&type=style&index=0&id=942a2bf4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "942a2bf4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/workspace/business/yq-monitor-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('942a2bf4')) {
      api.createRecord('942a2bf4', component.options)
    } else {
      api.reload('942a2bf4', component.options)
    }
    module.hot.accept("./Space.vue?vue&type=template&id=942a2bf4&scoped=true&", function () {
      api.rerender('942a2bf4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Space.vue"
export default component.exports